import React, { useEffect, useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import { useHomePageDataSelector } from ".";
import { ImgStatic } from "../../Common/element/ImgStatic";
import { TOP_CAROUSEL_IDS } from "../../../constants";
import { CarouselImg } from "../../Common/element/CarouselImg";

function TopContainer() {
  const carouselData = useHomePageDataSelector().carouselData;
  const [slot1, setSlot1] = useState(
    carouselData?.find((element) => element.slotId === TOP_CAROUSEL_IDS.TOP_1)
  );

  const [slot2, setSlot2] = useState(
    carouselData?.find((element) => element.slotId === TOP_CAROUSEL_IDS.TOP_2)
  );

  const [slot3, setSlot3] = useState(
    carouselData?.find((element) => element.slotId === TOP_CAROUSEL_IDS.TOP_3)
  );

  useEffect(() => {
    setSlot1(
      carouselData?.find((element) => element.slotId === TOP_CAROUSEL_IDS.TOP_1)
    );
    setSlot2(
      carouselData?.find((element) => element.slotId === TOP_CAROUSEL_IDS.TOP_2)
    );
    setSlot3(
      carouselData?.find((element) => element.slotId === TOP_CAROUSEL_IDS.TOP_3)
    );
    return () => {
      // cleanup
    };
  }, [carouselData]);
  return (
    <div className="container">
      <div className="row mb-5">
        <div className="col-lg-5">
          <ImgStatic name="company-logo-large.png" className="mt-sm-5" />
          <h1 className="font-weight-light mt-sm-5">
            Your One-Stop Appstore For Every Service
          </h1>
          <h5 className="mb-5 sub-text">Browse. Discover. Subscribe.</h5>
        </div>
        <div className="col-lg-7">
          <Carousel
            id="carouselExampleCaptions"
            className="slide carousel-1"
            data-ride="carousel"
            controls={false}
            interval={6000}
            keyboard={false}
            fade={true}
            slide={false}
          >
            <Carousel.Item>
              <CarouselImg
                className="carousel-item__image d-block w-100"
                src={slot1?.imagePathFragment || ""}
              />
            </Carousel.Item>
            <Carousel.Item>
              <CarouselImg
                className="carousel-item__image d-block w-100"
                src={slot2?.imagePathFragment || ""}
              />
            </Carousel.Item>
            <Carousel.Item>
              <CarouselImg
                className="carousel-item__image d-block w-100"
                src={slot3?.imagePathFragment || ""}
              />
            </Carousel.Item>
          </Carousel>
        </div>
      </div>
    </div>
  );
}

export default TopContainer;
